import { render, staticRenderFns } from "./PermissionSignatureList.vue?vue&type=template&id=10824b72&"
import script from "./PermissionSignatureList.vue?vue&type=script&lang=js&"
export * from "./PermissionSignatureList.vue?vue&type=script&lang=js&"
import style0 from "./PermissionSignatureList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports